import * as actionTypes from "./actionTypes";

export const toggleSaveCard = () => ({
    type: actionTypes.TOGGLE_SAVE_CARD
});

export const purchasePrepaidBalanceStart = () => ({
    type: actionTypes.PURCHASE_PREPAID_BALANCE_START
});

export const purchasePrepaidBalanceSuccess = () => ({
    type: actionTypes.PURCHASE_PREPAID_BALANCE_SUCCESS
});

export const purchasePrepaidBalanceFailure = () => ({
    type: actionTypes.PURCHASE_PREPAID_BALANCE_FAILURE
});

export const resetForm = () => ({
    type: actionTypes.RESET_FORM
});

export const handleQuantityInputChange = ({ quantityToAdd }) => ({
    type: actionTypes.HANDLE_QUANTITY_INPUT_CHANGE,
    quantityToAdd
});

export const setQuantityToAddInputError = ({ error }) => ({
    type: actionTypes.SET_QUANTITY_TO_ADD_INPUT_ERROR,
    error
});

export const clearQuantityToAddInputError = () => ({
    type: actionTypes.CLEAR_QUANTITY_TO_ADD_INPUT_ERROR
});

export const setUpdatingCard = ({ updatingCard }) => ({
    type: actionTypes.SET_UPDATING_CARD,
    updatingCard
});

export const setSavedCreditCard = ({ savedCreditCardInfo }) => ({
    type: actionTypes.SET_SAVED_CREDIT_CARD,
    savedCreditCardInfo
});

export const updateStripeFormData = ({
    stripeObjectInstance,
    stripeTokenData
}) => ({
    type: actionTypes.UPDATE_STRIPE_FORM_DATA,
    stripeObjectInstance,
    stripeTokenData
});

export const setCurrentPrepaidBalance = ({ currentPrepaidBalance }) => ({
    type: actionTypes.SET_CURRENT_PREPAID_BALANCE,
    currentPrepaidBalance
});

export const resetToDefault = ({
    currentPrepaidBalance,
    savedCreditCardInfo
}) => ({
    type: actionTypes.RESET_TO_DEFAULT,
    currentPrepaidBalance,
    savedCreditCardInfo
});
